import { allDay } from './AllDayToggle.locstring.json';
import { DefaultPalette } from '@uifabric/styling/lib/index';
import { ThemeProvider } from '@fluentui/react-theme-provider';
import { observer } from 'mobx-react-lite';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getToggleButtonTheme } from 'owa-component-styling-utils';
import loc from 'owa-localize';
import * as React from 'react';

const styles = require('./AllDayToggle.scss');
const classNames = require('classnames');

export interface AllDayToggleProps {
    isAllDay: boolean;
    onAllDayToggled: (isAllDay: boolean) => void;
    colorScheme: ColorScheme;
    className?: string;
    isDarkMode?: boolean;
    disabled?: boolean;
}

const AllDayToggle: React.SFC<AllDayToggleProps> = observer(props => {
    const { className, colorScheme, isAllDay, onAllDayToggled, isDarkMode, disabled } = props;

    const toggleTheme = getToggleButtonTheme(colorScheme, isDarkMode);

    return (
        <ThemeProvider theme={toggleTheme}>
            <Toggle
                checked={isAllDay}
                onChanged={onAllDayToggled}
                label={loc(allDay)}
                ariaLabel={loc(allDay)}
                className={classNames(className, styles.allDayToggle)}
                styles={{
                    root: {
                        whiteSpace: 'nowrap',
                        flexShrink: 0,
                        height: '32px',
                        margin: '0px',
                    },
                    label: {
                        margin: '0px 5px',
                    },
                    text: {
                        display: 'none',
                    },
                    pill: {
                        selectors: {
                            '.ms-Fabric--isFocusVisible &:focus:after': {
                                outline: `1px solid ${DefaultPalette.neutralSecondary} !important`,
                            },
                        },
                    },
                }}
                inlineLabel={true}
                // to take the space so that label appears before toggle
                // refer to https://developer.microsoft.com/en-us/fabric#/components/toggle for inlineLabel description
                onText={' '}
                offText={' '}
                disabled={disabled}
            />
        </ThemeProvider>
    );
});

export default AllDayToggle;
